<template>
  <v-chip
      :color="categoria.cor"
      :x-small="size === 'x-small'"
      :small="size === 'small'"
      dark
      :close="closeable"
      @click:close="$emit('close')"
      :class="chipClass"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <v-icon
        v-if="showIcon"
        :left="!iconOnly"
        :x-small="size === 'x-small'"
        :small="size === 'small'"
    >
      {{ categoria.icone }}
    </v-icon>
    <span v-if="!iconOnly">{{ categoria.nome }}</span>
  </v-chip>
</template>

<script>
export default {
  name: 'CategoriaChip',

  props: {
    categoria: {
      type: Object,
      required: true,
      validator: (val) => {
        return val.nome && val.cor && val.icone
      }
    },

    size: {
      type: String,
      default: 'small', // 'x-small', 'small', 'normal'
      validator: (val) => ['x-small', 'small', 'normal'].includes(val)
    },

    closeable: {
      type: Boolean,
      default: false
    },

    showIcon: {
      type: Boolean,
      default: true
    },

    iconOnly: {
      type: Boolean,
      default: false
    },

    outlined: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    chipClass() {
      return {
        'categoria-chip': true,
        'categoria-chip--outlined': this.outlined,
        'categoria-chip--icon-only': this.iconOnly,
        'categoria-chip--closeable': this.closeable
      }
    }
  }
}
</script>

<style scoped>
.categoria-chip {
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
}

.categoria-chip:hover {
  filter: brightness(1.1);
  transform: translateY(-1px);
}

.categoria-chip--outlined {
  border: 2px solid currentColor !important;
  background: transparent !important;
}

.categoria-chip--icon-only {
  min-width: auto !important;
  padding: 0 8px !important;
}

.categoria-chip--closeable {
  padding-right: 4px !important;
}

/* Animação de entrada */
.categoria-chip {
  animation: chip-slide-in 0.3s ease-out;
}

@keyframes chip-slide-in {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Responsivo */
@media (max-width: 768px) {
  .categoria-chip {
    font-size: 0.75rem;
  }
}
</style>